import script from "./VehicleCheckFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleCheckFormView.vue?vue&type=script&setup=true&lang=js"

import "./VehicleCheckFormView.vue?vue&type=style&index=0&id=8b46e924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b46e924"]])

export default __exports__